import { inject, Injectable } from '@angular/core';
import { CustomFormArray, CustomFormControl, CustomFormGroup } from '@tilby/tilby-ui-lib/components/tilby-magic-form';
import { ItemDefault } from '../../../../models/items-form.model';
import { Items } from 'tilby-models';
import { ItemGeneralFormService } from '../item-details/item-details-tabs/item-general/item-general-form.service';
import { ItemChannelsFormService } from '../item-details/item-details-tabs/item-channels/item-channels-form.service';
import { ItemDetailsSectionFormService } from '../item-details/item-details-tabs/item-details-section/item-details-section-form.service';
import { ItemStockFormService } from '../item-details/item-details-tabs/item-stock/item-stock-form.service';
import { ItemPrinterFormService } from '../item-details/item-details-tabs/item-printers/item-printers-form.service';
import { AbstractControl } from '@angular/forms';
import { ItemVariationsSectionService } from '../item-details/item-details-tabs/item-variations-section/item-variations-section.service';
import { VariationsFormService } from '../item-details/item-details-tabs/item-variations-section/variations/variations-form.service';
import { CombinationsFormService } from '../item-details/item-details-tabs/item-variations-section/combinations/combinations-form.service';

@Injectable()
export class ItemOperationsService {

  private readonly itemGeneralFormService = inject(ItemGeneralFormService);
  private readonly itemChannelsFormService = inject(ItemChannelsFormService);
  private readonly itemDetailsSectionFormService = inject(ItemDetailsSectionFormService);
  private readonly itemVariationsSectionFormService = inject(ItemVariationsSectionService);
  private readonly variationsFormService = inject(VariationsFormService);
  private readonly combinationsFormService = inject(CombinationsFormService);
  private readonly itemStockFormService = inject(ItemStockFormService);
  private readonly itemPrintersFormService = inject(ItemPrinterFormService);

  itemForm!: CustomFormGroup<any>;

  buildCurrentItem(baseItem: Items = new ItemDefault()): Items {
    let updatedItem = { ...baseItem };

    updatedItem = this.itemGeneralFormService.getGeneralFields(updatedItem);
    updatedItem = this.itemChannelsFormService.getChannelsFields(updatedItem);
    updatedItem = this.itemDetailsSectionFormService.getDetailsSectionFields(updatedItem);
    updatedItem = this.itemVariationsSectionFormService.getVariationsSectionFields(updatedItem);
    updatedItem = this.itemStockFormService.getStockFields(updatedItem);

    return updatedItem;
  }

  checkItemValidity() {

    const formServices = [
      { name: 'Generale', form: this.itemGeneralFormService.form },
      { name: 'Canali', form: this.itemChannelsFormService.form },
      { name: 'Dettagli', form: this.itemDetailsSectionFormService.form },
      { name: 'Varianti', form: this.itemVariationsSectionFormService.form },
      { name: 'Varianti', form: this.variationsFormService.form },
      { name: 'Varianti', form: this.combinationsFormService.form },
      { name: 'Magazzino', form: this.itemStockFormService.form },
      { name: 'Stampanti', form: this.itemPrintersFormService.form }
    ];

    let allInvalidFields: string[] = [];

    // Iterazione su tutti i form per cercare errori
    formServices.forEach(section => {
      if (section?.form?.invalid) {
          section.form.markAllAsTouched();

          // Ricerca dei campi specifici invalidi
          const invalidFields = this.findInvalidControlsRecursive(section.form);
          
          // Formattazione del messaggio (Es: "Generale > Nome Prodotto")
          const formattedErrors = invalidFields.map(field => `${section.name} > ${field}`);
          allInvalidFields = [...allInvalidFields, ...formattedErrors];
      }
    });
    
    if (allInvalidFields.length > 0) {
      allInvalidFields.forEach(invalid => {
      })
    }
    return allInvalidFields;
  }

  checkEmptyBomComponents(): boolean {
    return this.itemStockFormService.bomComponentsArray?.value.some((component: any) =>
      component.type === 'bom_component' && !component.bom_components.length
    ) || false;
  }

    /**
   * Restituisce una lista di stringhe con i percorsi dei campi invalidi.
   * Es: ['general.name', 'variations.0.name']
   */
  findInvalidControlsRecursive(rootControl: AbstractControl, path: string = ''): string[] {
    const invalidControls: string[] = [];

    if (rootControl.invalid && rootControl.errors) {
      invalidControls.push(path || 'root');
    }

    if (rootControl instanceof CustomFormGroup) {
      Object.keys(rootControl.controls).forEach(key => {
        const newPath = path ? `${path}.${key}` : key;
        const control = rootControl.get(key);
        
        if (control && control.invalid) {
          // Se è un controllo semplice (foglia), lo aggiungo
          if (control instanceof CustomFormControl) {
            if (!invalidControls.includes(newPath)) {
              invalidControls.push(newPath);
            }
          } 
          // Se è un gruppo o array, scendo ricorsivamente
          else {
            const childErrors = this.findInvalidControlsRecursive(control, newPath);
            childErrors.forEach(err => {
              if (!invalidControls.includes(err)) invalidControls.push(err);
            });
          }
        }
      });
    } else if (rootControl instanceof CustomFormArray) {
      rootControl.controls.forEach((control, index) => {
        const newPath = `${path}.${index}`;
        if (control.invalid) {
          const childErrors = this.findInvalidControlsRecursive(control, newPath);
          childErrors.forEach(err => {
            if (!invalidControls.includes(err)) invalidControls.push(err);
          });
        }
      });
    }

    return invalidControls;
  }
}
